import React, { useState } from 'react'
import Header from '../Header'
import Sidebar from '../Sidebar'
import Footer from '../Footer';
import Breadcrumb from '../common/Breadcrumb';
import DeleteModal from '../DeleteModal';
import { useSelector } from 'react-redux';
import { selectCommonDeleteModal } from '../../store/slices/common';

const Main = ({ crumbs, handleDelete, handleCandleDelete, children }) => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const deleteModal = useSelector(selectCommonDeleteModal);

    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
    };

    return (
        <>
            <Header toggleSidebar={toggleSidebar} />
            <Sidebar isSidebarOpen={isSidebarOpen} />
            <div className="p-4 sm:ml-0 md:ml-64 mt-16 main-container">
                {crumbs && <Breadcrumb crumbs={crumbs} />}
                <div className="p-4 pb-14 border-2 border-gray-200 border-dashed rounded-lg">
                    {children}
                </div>
            </div>
            <Footer />
            <DeleteModal handleDelete={handleDelete} isOpen={deleteModal} handleCandle={handleCandleDelete} />
        </>
    )
}

export default Main